import Layout from '../components/layout/index';
import Login from '../views/login/index.vue';
import Desk from '../views/desk/index.vue';
import { comicAuthRoutes } from './comic-auth';
import { workerRoutes } from './worker';
import { roleRoutes } from './role';
import { flowRoutes } from './flow';
import { statisticRoutes } from './statistic';
import { statisticNorRoutes } from './statistic-nor';
import { staffRoutes } from './staff';
import { demoRoutes } from './demo';
const customRoutes: any = [
  {
    path: '/login',
    hidden: true,
    name: 'login',
    isauth: false,
    component: Login
  },
  {
    path: '/sign',
    name: 'sign',
    isauth: false,
    component: () => import('../views/sign/index.vue')
  },
  {
    path: '/desk',
    redirect: '/desk',
    name: 'OA管理中心',
    icon: 'ift-book',
    component: Layout,
    children: [
      // 桌面
      {
        path: '',
        name: '',
        meta: {
          breadcrumbHidden: true
        },
        component: Desk
      },
      { ...demoRoutes },
      { ...comicAuthRoutes },
      { ...workerRoutes },
      { ...roleRoutes },
      { ...flowRoutes },
      { ...statisticRoutes },
      { ...statisticNorRoutes },
      { ...staffRoutes },
      // {
      //   path: 'sign',
      //   name: '标注',
      //   hidden: true,
      //   component: () => import('../views/sign/index.vue')
      // },
    ]
  }
];

export {
  customRoutes
};
